/**
 * @fileoverview PUT handler for the "/apps/:app_id/sdk_authentication_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdSdkAuthenticationSettingsCacheKeys } from "./constants";
import type { PutAppsAppIdSdkAuthenticationSettingsProps, AppsAppIdSdkAuthenticationSettingsResult } from "./types";

export const putAppsAppIdSdkAuthenticationSettings = reactQueryMutationAdapter(
  appsAppIdSdkAuthenticationSettingsCacheKeys,
  (props: PutAppsAppIdSdkAuthenticationSettingsProps): Promise<AppsAppIdSdkAuthenticationSettingsResult> => {
    return fetch(`/apps/${props.appId}/sdk_authentication_settings`, "PUT", props.reqData, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
